import React from "react";
import Play_Icon from "../../../../assets/new/play_icon.png";
import Pause_Icon from "../../../../assets/new/pause_icon.png";
export default function InsEN() {
  return (
    <>
      <h1>What is Savings?</h1>
      <p style={{ marginTop: "1rem", fontSize: "1rem" }}>
        Hello there! Welcome to Quick Learning Tool No. 5: What is Savings?{" "}
        <br />
        <br />
        Savings are key to financial well-being, offering a powerful tool for
        reaching future goals and handling unexpected expenses by setting aside
        a portion of income.
      </p>
      <br />
      <br />
      <h2>Activity Instructions</h2>
      <p style={{ marginTop: "1rem", fontSize: "1rem" }}>
        Start by clicking on the "Start" button to enter the interactive map.{" "}
        <br />
        <br />
        You will find three (3) clickable vendors on the map. Click on "Mareng
        Risa: Rice Dealer" vendor first to start the learning journey. Follow
        this order accordingly: <br />
        <br />
        1. Mareng Risa: Rice Dealer <br />
        2. Madam Burda: Handicraftsman <br />
        3. Sir Manny: Bank Manager <br /> <br />
        Once you click a vendor, a conversation will open up. Read it carefully.{" "}
        <br /> <br /> At some point, you will be presented with multiple-choice
        questions related to the savings discussed. Answer the questions to
        proceed. <br /> <br /> If you need to pause, click this icon{" "}
        <img src={Pause_Icon} style={{ width: ".65rem" }} /> . This temporarily
        stops the current conversation. Click{" "}
        <img src={Play_Icon} style={{ width: ".65rem" }} /> to continue from
        where you left off. <br /> <br />
        Finally, click on the "Finish" button once you reach the end of
        conversation with "Sir Manny: Bank Manager" to conclude the interactive
        activity.
      </p>
    </>
  );
}
